import React, {Component} from 'react';
import {Icon, ListView, NavBar, Toast,} from 'antd-mobile';
import {salesRecord} from "../../../../service/memberService";
import "./style.less";
import connect from "react-redux/es/connect/connect";
let pageIndex = 1;
let pageSize = 10;
@connect(
    state => ({userInfo: state.userInfo})
)
export default class Rebate extends Component {
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            dataSource,
            isLoading: true,
            notDataLoading:0,
            data:[]
        };
    }
    componentDidMount(){
        pageIndex = 1;
        let params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1,
            }
        };
        this.initData(params);
    }
    initData(params) {
        salesRecord(params).then((res)=>{
            if(res.data.code === '0000'){
                if (res.data.data.list.length > 0) {
                    this._setDataSource(res.data.data);
                }else {
                    this.setState({isLoading: false,notDataLoading:1});
                }
            }else{
                Toast.info(res.data.msg,3);
            }
        })
    }
    //数据拼接
    _setDataSource(data) {
        const allData = [...this.state.data, ...data.list];
        this.setState({
            dataSource: this.state.dataSource.cloneWithRows(allData),
            data: allData,
        });
        if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        }
    }
    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
            let params = {
                source:1,
                token: this.props.userInfo.token,
                data:{
                    pageSize: pageSize,
                    pageNum: ++pageIndex
                },
            };
            this.initData(params);
        }
    };
    getType(res){
        if(res.orderType == 1){
            return "预约出行订单"
        }
        if(res.orderType == 2){
            return "城内订单"
        }
        if(res.orderType == 3){
            return "专车预约订单"
        }
    }
    render(){
        const _renderRow = (res, index, rowID) => (
            <div className="list"  key={rowID}>
                <div className="top"><span>{res.createDate}</span><span>返利</span></div>
                <div className="bottom"><span>{this.getType(res)}{res.orderNum}</span><span className="pic">{"+"+res.rebateAmount}</span></div>
            </div>
        );
        return(
           <div className="rebates">
               <NavBar
                   className="navBar"
                   mode="light"
                   icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
               >返利明细</NavBar>
               <div className="content">
                   {
                       this.state.notDataLoading == 0  ?
                           <ListView
                               className="invoiceList"
                               ref={el => this.lv = el}
                               dataSource={this.state.dataSource}
                               renderFooter={() => (this.state.isLoading ? <Icon type="loading"/> : '没有更多')}
                               renderRow={_renderRow}
                               style={{
                                   height: '100%',
                                   overflow: 'auto',
                               }}
                               onEndReached={this._onEndReached.bind(this)}
                               scrollRenderAheadDistance={300}
                               onEndReachedThreshold={30}
                           />: <div className="noMore">暂无数据</div>
                   }
               </div>
           </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/Promote/Rebate/index.js